export default __webpack_public_path__ + "static/media/2.0bc15bfa.png";